import * as React from 'react';

// API
import apibridge from '../../../apibridge';

// UTILS
import { isObject, validationErrorsToString } from '../../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../../components/Button';
import LoadingSpinner from '../../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../../components/GlobalModal';

interface ExportDataModalTypes {
	organisationId?: string;
	closeModal?: closeModalType;
	onExportStarted?: () => void;
}

const ExportDataModal: React.FC<ExportDataModalTypes> = ({ organisationId, closeModal, onExportStarted }) => {
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');
	const [isLoading, setIsLoading] = React.useState<boolean>(false);
	const [confirmation, setConfirmation] = React.useState<string>('');

	const canExport = confirmation === 'EXPORT';

	const confirmExport = async () => {
		if (!organisationId || !canExport) {
			return;
		}

		setIsLoading(true);

		const response = await apibridge.postOrganisationExport({
			organisationId,
			confirmation: 'EXPORT'
		});

		if (isObject(response) && response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			if (onExportStarted) {
				onExportStarted();
			}
		}
	};

	return (
		<div className="modal-confirmation export-data-modal">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<form
								onSubmit={(event) => {
									event.preventDefault();

									if (canExport) {
										confirmExport();
									}
								}}
							>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4 mbtom-20">
									To confirm your request to export this organisation’s data, please type <strong>EXPORT</strong> in
									uppercase below.
								</h2>

								<input
									className="form-control text-center export-data-input "
									type="text"
									value={confirmation}
									onChange={(event) => setConfirmation(event.target.value)}
									autoComplete="off"
								/>

								<section className="actions mtop-30">
									<Button className="btn-primary full-width" disabled={!canExport} onClick={confirmExport}>
										Export
									</Button>

									<Button className="btn-secondary full-width" type="button" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</form>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ExportDataModal;
